export const getFullDate = (date: string): string => {
  if (!date) return "";
  const dateAndTime = date.split("T");
  return dateAndTime[0].split("-").reverse().join("-");
};
